// import { useState } from 'react'
import { Link } from 'react-router'
import TextToSpeech from '../components/TextToSpeech'
// import ExTextToSpeech from '../components/text2speedchandsave'


function Home() {
  const text =
    "Text-to-speech feature is now available on relatively any website or blog.";

  return (
    <div className="flex flex-col items-center pb-10 justify-center mt-8 h-full text-white bg-gradient-to-r from-indigo-500 from-10% via-sky-500 via-30% to-emerald-500 to-90%">
      <div className="max-w-5xl px-4 justify-center">
            <div className="flex flex-col lg:flex-row gap-6 p-8 flex-grow ">
              <div className="flex flex-row items-center justify-center gap-x-4 sm:p-6 mx-auto">
                <img 
                  src="/barcode.png" 
                  alt="barcode" 
                  width="200" 
                  height="200" 
                  className=" w-[10rem] mx-auto rounded-xl shadow-xl ring-1 ring-gray-400/10 sm:w-[12rem] md:-ml-4 lg:-ml-0"
                />
                <div className="">
                  <p className="indent-4 text-pretty text-2xl font-semibold tracking-tight text-white  sm:text-3xl">
                    Barcode Generator
                  </p>
                  <p className="indent-8 p-0  mt-2 text-sm sm:text-base text-gray-300">
                    Generate barcode with <b>FreelanceinTH</b> that it easy. this tool can support <b><i>CODE128 / EAN / UPC / CODE39 / ITF / MSI / Pharmacode / Codaba </i></b>
                  </p>
                  <Link to="/bargen" className="text-sm italic text-blue-700 rounded-full p-1 hover:text-blue-400 hover:bg-blue-600"> Go to BarGen...</Link>
                </div>
              </div>

              <div className="flex flex-row flex-grow items-center justify-center gap-x-4 sm:p-6 mx-auto ">
                <img 
                  src="/barcodescan.png" 
                  alt="barreader" 
                  width="400" 
                  height="250" 
                  className=" w-[10rem] mx-auto max-w-none rounded-xl shadow-xl ring-1 ring-gray-400/10 sm:w-[12rem] md:-ml-4 lg:-ml-0"
                />
                <div className="">
                  <p className="indent-4 text-pretty text-2xl font-semibold tracking-tight text-white  sm:text-3xl">
                    Barcode / QR code Reader
                  </p>
                  <p className="indent-8 p-0  mt-2 text-sm sm:text-base text-gray-300">
                   Scan Barcode / QR code with <b>FreelanceinTH</b> that it easy to read barcode from camera. this tool can support <b><i>CODE128 / EAN / UPC / CODE39 / ITF / MSI / Pharmacode / Codaba / Qr code </i></b>
                  </p>
                  <Link to="/barreader" className="text-sm italic text-blue-700 rounded-full p-1 hover:text-blue-400 hover:bg-blue-600"> Go to BarReader...</Link>
                </div>
              </div>
            </div>   

            <div className="flex flex-col lg:flex-row gap-6 p-8 flex-grow ">
              <div className="flex flex-row-reverse  items-center justify-center gap-x-4 sm:p-6 mx-auto">
                <img 
                  src="/qrcode.png" 
                  alt="barcode" 
                  width="200" 
                  height="200" 
                  className=" w-[10rem] mx-auto rounded-xl shadow-xl ring-1 ring-gray-400/10 sm:w-[12rem]"
                />
                <div className="">
                  <p className="indent-4 text-pretty text-2xl font-semibold tracking-tight text-white  sm:text-3xl">
                    QRcode Generator
                  </p>
                  <p className="indent-8 p-0  mt-2 text-sm sm:text-base text-gray-300">
                    Generate barcode with <b>FreelanceinTH</b> that it easy. 
                  </p>
                  <Link to="/qrgen" className="text-sm italic text-blue-700 rounded-full p-1 hover:text-blue-400 hover:bg-blue-600"> Go to QRGen...</Link>
                </div>
              </div>

              {/* <div className="flex flex-row-reverse  flex-grow items-center justify-center gap-x-4 sm:p-6 mx-auto ">
                <img 
                  src="/qrreader.png" 
                  alt="barreader" 
                  width="200" 
                  height="200" 
                  className=" w-[10rem] mx-auto max-w-none rounded-xl shadow-xl ring-1 ring-gray-400/10 sm:w-[12rem]"
                />
                <div className="">
                  <p className="indent-4 text-pretty text-2xl font-semibold tracking-tight text-white  sm:text-3xl">
                    QRcode Reader
                  </p>
                  <p className="indent-8 p-0  mt-2 text-sm sm:text-base text-gray-300">
                  Generate Reader with <b>FreelanceinTH</b> that it easy to read barcode from camera. 
                  </p>
                  <Link to="/htmlreader" className="text-sm italic text-blue-700 rounded-full p-1 hover:text-blue-400 hover:bg-blue-600"> Go to QRReader...</Link>
                </div>
              </div> */}
            </div>   
          {/* </div>
        </div>
      </div> */}
      <div className="sm:w-1/2 mx-auto rounded-2xl bg-gradient-to-br  from-sky-400 from-15% via-blue-800 via-40%">
        <TextToSpeech />
      </div>
      {/* <div className="flex flex-col p-2 gap-4">
      <h1>My Blog Post</h1>
        <ExTextToSpeech text={text} />
        <p>{text}</p>
      </div> */}
      </div>
    </div>
  )
}

export default Home